module.exports = __webpack_public_path__ + "media/images/real-effectis-08f085049872bc25d81025f3349335c6.png";